import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function CaseStudies({ content = {} }) {
  const [idx, setIdx] = useState(0);
  const caseStudies = (content.case_studies && content.case_studies.length) ? content.case_studies : [];
  const total = caseStudies.length || 1;
  const prev = () => setIdx((i) => (i - 1 + total) % total);
  const next = () => setIdx((i) => (i + 1) % total);

  if (caseStudies.length === 0) return null;

  return (
    <section className="bg-[#16243b] py-24 overflow-hidden">
      <div className="max-w-[1100px] mx-auto px-6">
        <div className="relative">
          <div className="overflow-hidden rounded-3xl">
            <div
              className="flex transition-transform duration-500 ease-out"
              style={{ transform: `translateX(-${idx * 100}%)` }}
            >
              {caseStudies.map((c, ci) => (
                <div key={ci} className="w-full flex-shrink-0">
                  <div className="grid md:grid-cols-2 bg-[#1e3050] rounded-3xl overflow-hidden">
                    <div className="h-[280px] md:h-auto">
                      <img src={c.image} alt={c.name} className="w-full h-full object-cover" />
                    </div>
                    <div className="p-10 flex flex-col justify-center">
                      <p className="text-[#2ec9c9] text-[3rem] font-bold leading-none">{c.stat}</p>
                      <p className="text-[#c9d2e0] text-[0.95rem] mb-6">{c.statLabel}</p>
                      <p className="text-white text-[1.15rem] leading-relaxed">“{c.quote}”</p>
                      <div className="flex items-center gap-4 mt-7">
                        <div>
                          <p className="text-white font-semibold text-[0.92rem] leading-tight">{c.name}</p>
                          <p className="text-[#8fa0b8] text-[0.8rem]">{c.role}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button onClick={prev} aria-label="Previous"
            className="absolute -left-3 sm:-left-6 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-white/10 border border-white/20 text-white flex items-center justify-center backdrop-blur hover:bg-[#2ec9c9] hover:border-[#2ec9c9] transition-colors">
            <ChevronLeft size={22} />
          </button>
          <button onClick={next} aria-label="Next"
            className="absolute -right-3 sm:-right-6 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-white/10 border border-white/20 text-white flex items-center justify-center backdrop-blur hover:bg-[#2ec9c9] hover:border-[#2ec9c9] transition-colors">
            <ChevronRight size={22} />
          </button>
        </div>

        <div className="flex justify-center gap-2 mt-8">
          {caseStudies.map((_, i) => (
            <button key={i} onClick={() => setIdx(i)} aria-label={`Case ${i + 1}`}
              className={`h-2 rounded-full transition-all ${i === idx ? "w-8 bg-[#2ec9c9]" : "w-2 bg-white/30"}`} />
          ))}
        </div>
      </div>
    </section>
  );
}
